import React, { useState, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { Form, Form2, Form3, Form4, Form5 } from './components';
import { NotifyModal, Page } from 'components';
import Results from '../Relatorio/components/Results/Results';
import Header from '../../components/Header/Header';
import Reload from '../../components/Reload/Reload';
import ApiGServer from 'services/ApiGServer';
import ApiMServer from 'services/ApiMServer';
import ApiGSenha from 'services/ApiGSenha';
import dateformat from 'utils/dateformat';
import copy from 'clipboard-copy';
import { getModernDataTableMetaClass } from 'utils/tableTheme';

const EquipmentsDetail = (props) => {

  const { serial } = props.match.params;
  const [serials,] = useState(serial);

  const user = JSON.parse(localStorage.getItem('userData'));
  if (user?.permission?.equipments?.read !== true) {
    window.location.replace('/home');
  }
  const [loading, setLoading] = useState(true);

  const [equipments, setEquipments] = useState({
    _id: '',
    charts: {
      principal: '',
      complementar: ''
    },
    daystoactivate: '',
    equipid: '',
    serialnumber: '',
    serialnumbersequence: '',
    cupid: '',
    lastlat: '',
    lastlng: '',
    versaosw: '',
    versaofwpri: '',
    versaofwosc: '',
    sha1curva: '',
    createdAt: '',
    updatedAt: '',
    mode: '',
    dcal: '',
    isentkey: false,
    plan: '',
    observation: '',
    config_temp: 60,
    tray: false,
    scan_face: false,
    full_tracking: false,
  });

  const [unlock, setUnlock] = useState({
    email: '',
    name: '',
    lat: '',
    lng: '',
    sn: '',
    password: '',
    createdAt: '',
    updatedAt: '',
    address: ''
  });

  const [passwordGenerate, setPasswordGenerate] = useState({
    token: '',
    address: ''
  });

  const [permission, setPermission] = useState(false);
  const [password, setPassword] = useState('');

  const [unlocks, setUnlocks] = useState([]);
  const [empresa, setEmpresa] = useState('')
  const [textButton, setTextButton] = useState('Copiar Link do Certificado')
  const [showResults, setShowResults] = useState(false); // Estado para controlar a exibição dos resultados

  const [type, setType] = useState({ "color": "", "status": "" });
  const [modalShow, setModalShow] = useState(false);

  const [locationData, setLocationData] = useState({
    address: '',
    lat: null,
    lng: null,
  });

  const handleAlertModalSuccess = (msg) => {
    setType({ "color": "#198754", "status": msg })
    setModalShow(true)
  }

  const handleAlertModalError = (msg) => {
    setType({ "color": "red", "status": msg })
    setModalShow(true)
  }

  const handleShowResults = () => {
    setShowResults(true); // Exibe os resultados
    // Scroll suave até a seção de resultados após mostrar
    setTimeout(() => {
      if (componentRef.current) {
        componentRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 300);
  };

  useEffect(() => {
    const { permission } = JSON.parse(localStorage.getItem('userData'));
    setPermission(permission.equipments.write);
  }, []);

  useEffect(() => {
    let isMounted = true; // Evita atualização após desmontar

    const fetchData = async () => {
      const config = { headers: { serialnumber: serials } };

      try {
        const [empresaRes, equipmentsRes, allunlock] = await Promise.allSettled([
          ApiMServer.post(`/company/companybyserialnumber`, { serialnumber: serials }),
          ApiGServer.get(`/equipment/get`, config),
          ApiGSenha.post(`/log/allunlock`, { serialnumber: serials })
        ]);

        if (isMounted) {
          // Empresa
          if (empresaRes.status === "fulfilled" && empresaRes.value?.data) {
            setEmpresa(empresaRes.value.data);
          } else if (empresaRes.status === "rejected") {
            console.error("Erro ao buscar empresa:", empresaRes.reason);
          }

          // Equipamentos
          if (equipmentsRes.status === "fulfilled" && equipmentsRes.value?.data) {
            const data = equipmentsRes.value.data;
            data.daystoactivate = parseInt(data.daystoactivate, 16);
            setEquipments(data);
          } else if (equipmentsRes.status === "rejected") {
            console.error("Erro ao buscar equipamentos:", equipmentsRes.reason);
          }

          // Log de desbloqueio
          if (allunlock.status === "fulfilled" && allunlock.value?.data) {
            const data = allunlock.value.data;
            setUnlocks(data);
            if (data?.length > 0) {
              let unlock = { ...data[0] } || {};
              unlock.updatedAt = dateformat(unlock.updatedAt || '');
              unlock.createdAt = dateformat(unlock.createdAt || '');
              setUnlock(unlock);
            }
          } else if (allunlock.status === "rejected") {
            console.error("Erro ao buscar log de desbloqueio:", unlock.reason);
          }

        }
      } catch (err) {
        console.error("Erro inesperado ao carregar dados:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [serials]);

  const handleFieldChange = (event, field, value) => {
    event.persist && event.persist();
    //if (field === 'daystoactivate') value = value <= 1 ? 1 : value > 4095 ? 1 : value;
    setEquipments((values) => ({
      ...values,
      [field]: value
    }));
  };

  const handleFieldChangeUnlock = (event, field, value) => {
    event.persist && event.persist();
    setUnlock((values) => ({
      ...values,
      [field]: value
    }));
  };

  const handleFildChangePasswordGenerate = (event, field, value) => {
    event.persist && event.persist();
    setPasswordGenerate((values) => ({
      ...values,
      [field]: value
    }));
  };

  const handleSubmit = async () => {
    let value = parseInt(equipments?.daystoactivate ? equipments.daystoactivate : 0);

    if (isNaN(value)) {
      handleAlertModalError('O campo dias para Ativação deve ser preenchido com um número inteiro!')
      return;
    }

    if (value < 0 || value > 4095) {
      handleAlertModalError('O número de dias para Ativação deve estar entre 0 e 4095!');
      return;
    }

    try {
      let { data } = await ApiGServer.patch(`/equipment/update`, {
        serialnumber: serials,
        daystoactivate: Number(equipments.daystoactivate).toString(16).toUpperCase(),
        observation: equipments.observation,
        tray: equipments.tray,
        config_temp: equipments.config_temp,
        scan_face: equipments.scan_face,
        full_tracking: equipments.full_tracking,
        lat: locationData.lat || equipments.lat,
        lng: locationData.lng || equipments.lng
      });
      data.daystoactivate = parseInt(data.daystoactivate, 16);
      setEquipments(data)
      handleAlertModalSuccess('Atualizado com Sucesso!');
    } catch (e) {
      console.error("Erro ao atualizar dias para ativação:", e);
      handleAlertModalError('Falha ao atualizar! Verifique a conexão ou tente novamente.');
    }
  };

  const handlePasswordGenerate = async () => {
    if (!passwordGenerate.token) {
      alert('Insira o token!');
      return;
    }

    if (!locationData.lat || !locationData.lng) {
      alert('Insira o endereço!');
      return;
    }

    let user = JSON.parse(localStorage.getItem('userData'));

    let json = {
      serialnumber: equipments.serialnumber,
      type: 'unblock',
      key: passwordGenerate.token,
      name: user.name,
      email: user.email,
      lat: locationData.lat || equipments.lat,
      lng: locationData.lng || equipments.lng
    };

    try {
      const resp = await ApiGSenha.post('/password/unblock', json);
      if (resp?.data?.code) {
        setPassword(resp.data.code);
        handleAlertModalSuccess('Senha gerada com sucesso!');
      } else {
        handleAlertModalError('Não foi possível gerar a senha');
      }
    } catch (error) {
      console.error("Erro ao gerar senha:", error);
      handleAlertModalError('Falha ao gerar senha! Verifique o token e tente novamente.');
    }
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  });

  const handlePlan = (newPlan) => {
    setEquipments((prevEquipments) => ({
      ...prevEquipments,
      plan: newPlan
    }));

    (async () => {
      try {
        await ApiGServer.post(`/equipment/updateplan`, { filter: [serials], plan: newPlan });
        handleAlertModalSuccess('Plano atualizado com sucesso!');
      } catch (error) {
        console.error("Erro ao atualizar plano:", error);
        handleAlertModalError('Falha ao atualizar o plano!');
        // Reverte a alteração em caso de falha
        setEquipments((prevEquipments) => ({
          ...prevEquipments,
          plan: prevEquipments.plan
        }));
      }
    })();
  }

  const checkboxChange = (value) => {
    const newMode = value ? 'RENTAL' : 'OWNER';

    // Salva o modo atual para possível reversão
    const currentMode = equipments.mode;

    // Atualiza o estado local otimisticamente
    setEquipments((values) => ({
      ...values,
      'mode': newMode
    }));

    (async () => {
      try {
        await ApiGServer.post(`/equipment/updatemode`, {
          serialnumber: serials,
          mode: newMode
        });
        handleAlertModalSuccess('Modo atualizado com sucesso!');
      } catch (error) {
        console.error("Erro ao atualizar modo:", error);
        handleAlertModalError('Falha ao atualizar o modo!');
        // Reverte a alteração em caso de falha
        setEquipments((values) => ({
          ...values,
          'mode': currentMode
        }));
      }
    })();
  }

  const checkboxIsentChange = (value) => {
    // Salva o valor atual para possível reversão
    const currentIsentKey = equipments.isentkey;

    // Atualiza o estado local otimisticamente
    setEquipments((values) => ({
      ...values,
      'isentkey': value
    }));

    (async () => {
      try {
        await ApiGServer.post('/equipment/update/isentkey', {
          serialnumber: equipments.serialnumber,
          isentkey: value
        });
        handleAlertModalSuccess('Isenção de taxas atualizada com sucesso!');
      } catch (error) {
        console.error("Erro ao atualizar isenção de taxas:", error);
        handleAlertModalError('Falha ao atualizar isenção de taxas!');
        // Reverte a alteração em caso de falha
        setEquipments((values) => ({
          ...values,
          'isentkey': currentIsentKey
        }));
      }
    })();
  }

  const handleCopyToClipboard = (link) => {
    try {
      copy(link);
      setTextButton('Link Copiado');
      setTimeout(() => setTextButton('Copiar Link do Certificado'), 3000); // Reset após 3 segundos
    } catch (error) {
      console.error("Erro ao copiar para a área de transferência:", error);
      handleAlertModalError('Não foi possível copiar o link!');
    }
  }

  // Função utilitária para converter dados em CSV e baixar
  const handleDownloadCSV = () => {
    try {
      if (!unlocks || unlocks.length === 0) {
        handleAlertModalError('Não há dados para exportar!');
        return;
      }

      // Apenas os campos solicitados
      const header = [
        'serialnumber', 'name', 'email', 'createdAt', 'lat', 'lng', 'versaosw',
        'updatedAt', 'address', 'user.cpfcnpj', 'copo', 'cupid'
      ];

      // Cabeçalho legível para o usuário
      const csvHeader = [
        'SERIAL', 'NOME', 'E-MAIL', 'DATA', 'LATITUDE', 'LONGITUDE', 'SOFTWARE',
        'DATA ATUALIZAÇÃO', 'ENDEREÇO', 'CPF/CNPJ', 'COPO', 'ID DO COPO'
      ];

      const csvRows = [csvHeader.join(';')];

      unlocks.forEach(row => {
        csvRows.push([
          row.serialnumber || '',
          row.name || '',
          row.email || '',
          row.createdAt ? dateformat(row.createdAt) : '',
          row.lat || '',
          row.lng || '',
          row.versaosw || '',
          row.updatedAt ? dateformat(row.updatedAt) : '',
          row.address || '',
          row.user?.cpfcnpj || '',
          row.copo || '',
          row.cupid || ''
        ].map(field => `"${String(field).replace(/"/g, '""')}"`).join(';'));
      });

      const csvContent = csvRows.join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `ativacoes_${serials}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      handleAlertModalSuccess('Arquivo CSV baixado com sucesso!');
    } catch (error) {
      console.error("Erro ao baixar CSV:", error);
      handleAlertModalError('Falha ao baixar o arquivo CSV!');
    }
  };

  return (
    <Page className="p-3" title="Equipamentos">
      <Header page="Equipamentos" />

      <NotifyModal
        type={type}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      {loading && <Reload />}

      <Card className='mb-2 mt-2 p-2'>
        <Row>
          <Col>
            <Button
              className='ms-2 mt-2 mb-2'
              onClick={() => { handleCopyToClipboard(`${process.env.REACT_APP_API_FILE_SERVER}/download/certificado/${equipments.serialnumber}-${equipments.cupid}`, "_blank") }}
              disabled={!equipments.dcal}
              variant="success"
            >
              {textButton}
            </Button>
          </Col>
        </Row>
      </Card>

      <Form
        permission={permission}
        equipments={equipments}
        onSubmit={handleSubmit}
        fieldChange={handleFieldChange}
        checkboxChange={checkboxChange}
        checkboxIsentChange={checkboxIsentChange}
        handleAlertModalSuccess={handleAlertModalSuccess}
        handleAlertModalError={handleAlertModalError}
        empresa={empresa}
        setLocationData={setLocationData}
        handlePlan={handlePlan}
      />

      <Form2
        user={user}
        unlock={unlock}
        fieldChange={handleFieldChangeUnlock}
      />

      <Form3
        permission={permission}
        onSubmit={handlePasswordGenerate}
        fieldChange={handleFildChangePasswordGenerate}
        password={password}
        setLocationData={setLocationData}
      />

      {serial.includes('SIMT') && (
        <Form5
          serial={serial}
        />
      )}

      {serial.includes('SIMT') && (
        <Form4
          serial={serial}
        />
      )}

      <Card>
        <Card.Header>
          <Button
            className="mt-2 mb-2"
            onClick={handleShowResults}
            variant="success"
          >
            Ver Ativações
          </Button>

          <Button
            className='mt-2 mb-2 ms-2'
            onClick={handlePrint}
            variant="outline-success"
            disabled={!showResults}
          >
            Imprimir
          </Button>

          <Button
            className='mt-2 mb-2 ms-2'
            onClick={handleDownloadCSV}
            variant="outline-primary"
            disabled={!showResults}
          >
            Baixar CSV
          </Button>
        </Card.Header>

        <Card.Body>
          <div ref={componentRef}>
            {showResults && equipments ? (
              <Results data={unlocks} />
            ) : (
              !showResults && (
                <p className={getModernDataTableMetaClass()}>Clique em "Ver Resultados" para visualizar os dados e imprimir.</p>
              )
            )}
          </div>
        </Card.Body>
      </Card>
    </Page>
  );
};

export default EquipmentsDetail;
